import script from "./promoPageRegHackForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./promoPageRegHackForm.vue?vue&type=script&lang=ts&setup=true"

import "./promoPageRegHackForm.vue?vue&type=style&index=0&id=62942460&lang=scss&scoped=true"

import exportComponent from "/home/sergiy/projects/magnetics/promo.land/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62942460"]])

export default __exports__